import { Button } from './ui/button.jsx';

const ContactsInfo = () => {
  return (
    <div className="mt-6 w-full text-sm">
      <p>
        Para esclarecimentos adicionais, por favor, dirija-se ao Balcão de
        Informações do MAR Shopping Matosinhos (piso 0).
      </p>
      <p>
        Consulte os nossos contactos{' '}
        <Button asChild variant="link" className="h-auto p-0">
          <a
            href="https://www.marshopping.com/matosinhos/pt/contatos"
            target="_blank"
            rel="noreferrer"
          >
            aqui
          </a>
        </Button>
      </p>
    </div>
  );
};

export default ContactsInfo;
